{
  "nl": {
    "issue_status": {
      "actions": {
        "create": "Puntenstatus maken"
      },
      "labels": {
        "customer_status": "Klant zal zien",
        "internal_status": "Interne status",
        "new_issue_status": "Status"
      }
    }
  }
}